import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addressInfoBoxLineDelivery: 'Delivery takes about 1-2 weeks on average',
    addressInfoBoxTitle: 'Your delivery address',
    cardName: 'Physical {0} card',
    deliveryTime: '1 to 2 weeks',
    errorBoxNotEnoughFunds:
      'There are insufficient funds to cover this order, please make sure your balance is sufficient to order your card.',
    labelCardAdditionalPrice: 'Additional card fee',
    labelDeliveryTime: 'Delivery time',
    labelShippingPrice: 'Shipping',
    orderCta: 'Order my card',
    orderErrorMessage: 'Your card could not be ordered, please try again',
    price: '**€{0}**',
    priceFree: '**Free**',
    pricePerMonth: '**€{0}**/month',
    sidebarImgAlt: 'Your professional card',
    subtitle: 'Check your order information before validating it:',
    title: 'Your order summary',
    vatMention: 'Prices are displayed without VAT',
  },
  fr: {
    addressInfoBoxLineDelivery:
      'La livraison prend environ 1 à 2 semaines en moyenne',
    addressInfoBoxTitle: 'Adresse de livraison',
    cardName: 'Carte {0} physique',
    deliveryTime: '1 à 2 semaines',
    errorBoxNotEnoughFunds:
      'Les fonds sont insuffisants pour cette commande, veuillez vous assurer que votre solde est suffisant pour commander votre carte.',
    labelCardAdditionalPrice: "Frais d'édition de carte",
    labelDeliveryTime: 'Délais de livraison',
    labelShippingPrice: 'Frais de port',
    orderCta: 'Commander ma carte',
    orderErrorMessage: `Votre carte n'a pas pu être commandée, veuillez réessayer`,
    price: '**{0}\xA0€**',
    priceFree: '**Gratuit**',
    pricePerMonth: '**{0}\xA0€**/mois',
    sidebarImgAlt: 'Votre carte professionnelle',
    subtitle:
      'Vérifiez les informations de votre commande avant de la valider\xA0:',
    title: 'Récapitulatif de votre commande',
    vatMention: 'Les prix sont affichés hors taxes.',
  },
} as const);

export default locales;
